import Vue from 'vue';
import ApolloClient from 'apollo-boost';
import VueApollo from 'vue-apollo';

import { SessionStorage } from './enums/sessionStorage.enum';
import { config } from './utils/config';

Vue.use(VueApollo);

export const apolloClient = new ApolloClient({
  uri: config.graphQLURL,
  request: async operation => {
    const token = sessionStorage.getItem(SessionStorage.TOKEN);
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      });
    }
  }
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

export default apolloProvider;
